import React from "react"
import { useEffect, useState } from "react"

export let setGlobalModal:(Element) => void

export const ModalHost = () => {
  const [Modal, setModal] = useState(<></>)
  useEffect(() => {
    setGlobalModal = setModal
  }, [])
  return Modal
}
